import crypto from 'crypto';
/**
 * Encrypts a string using AES-256-GCM with a fixed IV and double base64-encoded ciphertext.
 *
 * The output format is a concatenation of:
 * - IV (base64-encoded, fixed value "vBKbi8c6vCyvWonV")
 * - Authentication tag (base64-encoded, 16 bytes → 24 characters in base64)
 * - Ciphertext (double base64-encoded)
 *
 * The `key` is hashed with SHA-256, truncated to 32 bytes, and used as the AES key.
 * The ciphertext is first base64-encoded after encryption, then encoded to base64 again to match
 * the format used by the backend.
 *
 * @param {string} secret - The plaintext string to encrypt.
 * @param {string} [key=""] - The secret key used for encryption (before SHA-256 hashing).
 * @returns {string} The encrypted string in the backend-compatible format.
 *
 * @throws {Error} If encryption fails.
 */

function encryptAES256GCM(secret, key = '') {
  const masterkey = key ||  process.env.VUE_APP_GCM_SECRET;

  const password = crypto.createHash("sha256").update(masterkey).digest().subarray(0, 32);

  const iv = Buffer.from("vBKbi8c6vCyvWonV", "base64");

  const cipher = crypto.createCipheriv("aes-256-gcm", password, iv);

  const rawCiphertext = Buffer.concat([
    cipher.update(secret, "utf8"),
    cipher.final()
  ]);

  const tag = cipher.getAuthTag();

  const ciphertextDoubleBase64 = Buffer.from(rawCiphertext.toString("base64")).toString("base64");

  const encrypted =
        iv.toString("base64") +
        tag.toString("base64") +
        ciphertextDoubleBase64;

  return encrypted;
}

export default encryptAES256GCM;